module.exports = __webpack_public_path__ + "img/home_icon3.20f81a7e.png";